module.exports = __webpack_public_path__ + "assets/img/wh.b423c923.jpg";